import axios from "axios";
import url from "@/utils/api/url";

const URL_PROJECT = url.URL_API + '/project';

// 与项目类型相关的URL
const URL_PROJECT_CATEGORY = URL_PROJECT + '/category';

// 与批次信息相关的URL
const URL_PROJECT_BATCH = URL_PROJECT + '/batch';
const URL_PROJECT_BATCH_STATE = URL_PROJECT + '/batch/state';
const URL_PROJECT_BATCH_CONTACT = URL_PROJECT + '/batch/contact';
const URL_PROJECT_BATCH_REQUIREMENT = URL_PROJECT + '/batch/requirement';
const URL_PROJECT_BATCH_CATEGORY = URL_PROJECT + '/batch/category';

// 与项目信息相关的URL
const URL_PROJECT_PROJECT = URL_PROJECT + '/project';
const URL_PROJECT_PROJECT_STATE = URL_PROJECT + '/project/state';
const URL_PROJECT_PROJECT_PUBLISH_ALL = URL_PROJECT + '/project/publishAll';
const URL_PROJECT_PROJECT_IMPLEMENTATION = URL_PROJECT + '/project/implementation';
const URL_PROJECT_PROJECT_TEACHER_COURSE = URL_PROJECT + '/project/teacherCourse';
const URL_PROJECT_PROJECT_TEACHER_COURSE_COMMON = URL_PROJECT + '/project/teacherCourse/common';
const URL_PROJECT_PROJECT_ASSESSMENT = URL_PROJECT + '/project/assessment';
const URL_PROJECT_PROJECT_ACHIEVEMENT = URL_PROJECT + '/project/achievement';

// 与项目教学班级信息相关的URL
const URL_PROJECT_CLASS = URL_PROJECT + '/class';
const URL_PROJECT_CLASS_STATE = URL_PROJECT + '/class/state';
const URL_PROJECT_CLASS_SCHEDULE = URL_PROJECT + '/class/schedule';
const URL_PROJECT_CLASS_SCHEDULE_IMPORT = URL_PROJECT + '/class/schedule/import';

//二期增加功能
//项目状态相关
const URL_PROJECT_STATE_CHANGE = URL_PROJECT + '/project/state/change';
//基地填写项目信息增加必填项验证：页面填写内容除（添加通识课程信息）外均为必填项，若有一项未填写 点击【提交审核】提示“项目信息请填写完整！
const URL_CHECK_PROJECT_INFO = URL_PROJECT + '/checkProjectInfo';

//班级状态相关
const URL_CLASS_STATE_CHANGE = URL_PROJECT + '/class/state/change';

//查询批次确定实施下的项目
const URL_CONFIRM_PROJECT = URL_PROJECT + '/project/confirm';

export default {
    category: {
        getProjectCategoryData() {
            return axios.get(URL_PROJECT_CATEGORY);
        },
        getProjectCategoryInfo(categoryId) {
            return axios.get(URL_PROJECT_CATEGORY + '/' + categoryId);
        },
        insertProjectCategoryInfo(info) {
            return axios.post(URL_PROJECT_CATEGORY, info);
        },
        updateProjectCategoryInfo(info) {
            return axios.put(URL_PROJECT_CATEGORY + '/' + info.categoryId, info);
        }
    },
    batch: {
        getProjectBatchData() {
            return axios.get(URL_PROJECT_BATCH);
        },
        getProjectBatchDataOrgan() {
            return axios.get(URL_PROJECT_BATCH + '/organ');
        },
        getProjectBatchInfo(batchId) {
            return axios.get(URL_PROJECT_BATCH + '/' + batchId);
        },
        insertProjectBatchInfo(info) {
            return axios.post(URL_PROJECT_BATCH, info);
        },
        updateProjectBatchInfo(info) {
            return axios.put(URL_PROJECT_BATCH + '/' + info.batchId, info);
        },
        updateProjectBatchState(info) {
            return axios.put(URL_PROJECT_BATCH_STATE + '/' + info.batchId, info);
        },
        getReviewProjectByBatch(batchId) {
            return axios.get(URL_PROJECT_BATCH + '/review/' + batchId);
        },
        checkBatchReview(batchId) {
            return axios.get(URL_PROJECT_BATCH + '/checkReview/' + batchId);
        },

        requirement: {
            getProjectBatchRequirementInfo(batchId) {
                return axios.get(URL_PROJECT_BATCH_REQUIREMENT + '/' + batchId);
            },
            updateProjectBatchRequirementInfo(info) {
                return axios.put(URL_PROJECT_BATCH_REQUIREMENT + '/' + info.batchId, info);
            },
        },
        contact: {
            getProjectBatchContactData(batchId) {
                return axios.get(URL_PROJECT_BATCH_CONTACT, {params: {batchId}});
            },
            getProjectBatchContactInfo(pkId) {
                return axios.get(URL_PROJECT_BATCH_CONTACT + '/' + pkid);
            },
            insertProjectBatchContactInfo(info) {
                return axios.post(URL_PROJECT_BATCH_CONTACT, info);
            },
            deleteProjectBatchContactInfo(pkId) {
                return axios.delete(URL_PROJECT_BATCH_CONTACT + '/' + pkId);
            },
        },
        category: {
            getProjectBatchCategoryData(batchId) {
                return axios.get(URL_PROJECT_BATCH_CATEGORY, {params: {batchId}});
            },
            getProjectBatchCategoryInfo(batchCategoryId) {
                return axios.get(URL_PROJECT_BATCH_CATEGORY + '/' + batchCategoryId);
            },
            insertProjectBatchCategoryInfo(info) {
                return axios.post(URL_PROJECT_BATCH_CATEGORY, info);
            },
            deleteProjectBatchCategoryInfo(batchCategoryId) {
                return axios.delete(URL_PROJECT_BATCH_CATEGORY + '/' + batchCategoryId);
            },
        },
    },

    project: {
        getProjectDataWithPaging(filterCondition) {
            return axios.get(URL_PROJECT_PROJECT, {params: filterCondition});
        },
        getProjectInfo(projectId) {
            return axios.get(URL_PROJECT_PROJECT + '/' + projectId);
        },
        insertProjectInfo(info) {
            return axios.post(URL_PROJECT_PROJECT, info);
        },
        updateProjectInfo(info) {
            return axios.put(URL_PROJECT_PROJECT + '/' + info.projectId, info);
        },
        updateProjectState(info) {
            return axios.put(URL_PROJECT_PROJECT_STATE + '/' + info.projectId, info);
        },
        publishAllProject(batchId) {
            return axios.put(URL_PROJECT_PROJECT_PUBLISH_ALL + '/' +batchId);
        },
        updateProjectStateById(info) {
            return axios.post(URL_PROJECT_STATE_CHANGE, info)
        },
        checkProjectInfo(projectId) {
            return axios.get(URL_CHECK_PROJECT_INFO + '/' + projectId)
        },

        implementation: {
            getProjectImplementationInfo(projectId) {
                return axios.get(URL_PROJECT_PROJECT_IMPLEMENTATION + '/' + projectId);
            },
            updateProjectImplementationInfo(info) {
                return axios.put(URL_PROJECT_PROJECT_IMPLEMENTATION + '/' + info.projectId, info);
            },
        },
        teacherCourse: {
            getProjectTeacherCourseData(projectId) {
                return axios.get(URL_PROJECT_PROJECT_TEACHER_COURSE, {params: {projectId}});
            },
            getProjectTeacherCourseInfo(courseTeacherId) {
                return axios.get(URL_PROJECT_PROJECT_TEACHER_COURSE + '/' + courseTeacherId);
            },
            insertProjectTeacherCourseInfo(info) {
                return axios.post(URL_PROJECT_PROJECT_TEACHER_COURSE, info);
            },
            updateProjectTeacherCourseInfo(info) {
                return axios.put(URL_PROJECT_PROJECT_TEACHER_COURSE + '/' + info.courseTeacherId, info);
            },
            deleteProjectTeacherCourseInfo(courseTeacherId) {
                return axios.delete(URL_PROJECT_PROJECT_TEACHER_COURSE + '/' + courseTeacherId);
            },

            common: {
                getProjectCommonTeacherCourseData(projectId) {
                    return axios.get(URL_PROJECT_PROJECT_TEACHER_COURSE_COMMON, {params: {projectId}});
                },
                insertProjectCommonTeacherCourseInfo(projectId, courseTeacherId) {
                    return axios.post(URL_PROJECT_PROJECT_TEACHER_COURSE_COMMON, {projectId, courseTeacherId});
                },
                deleteProjectCommonTeacherCourseInfo(pkId) {
                    return axios.delete(URL_PROJECT_PROJECT_TEACHER_COURSE_COMMON + '/' + pkId);
                }
            }
        },
        assessment: {
            getProjectAssessmentData(projectId) {
                return axios.get(URL_PROJECT_PROJECT_ASSESSMENT, {params: {projectId}});
            },
            getProjectAssessmentInfo(assessmentId) {
                return axios.get(URL_PROJECT_PROJECT_ASSESSMENT + '/' + assessmentId);
            },
            insertProjectAssessmentInfo(info) {
                return axios.post(URL_PROJECT_PROJECT_ASSESSMENT, info);
            },
            updateProjectAssessmentInfo(info) {
                return axios.put(URL_PROJECT_PROJECT_ASSESSMENT + '/' + info.assessmentId, info);
            },
            deleteProjectAssessmentInfo(assessmentId) {
                return axios.delete(URL_PROJECT_PROJECT_ASSESSMENT + '/' + assessmentId);
            },
        },
        achievement: {
            getProjectAchievementData(projectId) {
                return axios.get(URL_PROJECT_PROJECT_ACHIEVEMENT, {params: {projectId}});
            },
            getProjectAchievementInfo(achievementId) {
                return axios.get(URL_PROJECT_PROJECT_ACHIEVEMENT + '/' + achievementId);
            },
            insertProjectAchievementInfo(info) {
                return axios.post(URL_PROJECT_PROJECT_ACHIEVEMENT, info);
            },
            updateProjectAchievementInfo(info) {
                return axios.put(URL_PROJECT_PROJECT_ACHIEVEMENT + '/' + info.achievementId, info);
            },
            deleteProjectAchievementInfo(achievementId) {
                return axios.delete(URL_PROJECT_PROJECT_ACHIEVEMENT + '/' + achievementId);
            },
        }
    },

    class: {
        getProjectClassData(projectId) {
            return axios.get(URL_PROJECT_CLASS, {params: {projectId}});
        },
        getProjectClassInfo(classId) {
            return axios.get(URL_PROJECT_CLASS + '/' + classId);
        },
        insertProjectClassInfo(info) {
            return axios.post(URL_PROJECT_CLASS, info);
        },
        updateProjectClassInfo(info) {
            return axios.put(URL_PROJECT_CLASS + '/' + info.classId, info);
        },
        deleteProjectClassInfo(classId) {
            return axios.delete(URL_PROJECT_CLASS + '/' + classId);
        },
        updateProjectClassState(info) {
            return axios.put(URL_PROJECT_CLASS_STATE + '/' + info.classId, info);
        },
        updateClassState(info){
            return axios.post(URL_CLASS_STATE_CHANGE, info);
        },

        schedule: {
            getProjectClassScheduleData(classId) {
                return axios.get(URL_PROJECT_CLASS_SCHEDULE, {params: {classId}});
            },
            getProjectClassScheduleTempData(projectId) {
                return axios.get(URL_PROJECT_CLASS_SCHEDULE + '/temp', {params: {projectId}});
            },
            getProjectClassScheduleInfo(scheduleId) {
                return axios.get(URL_PROJECT_CLASS_SCHEDULE + '/' + scheduleId);
            },
            insertProjectClassScheduleInfo(info) {
                return axios.post(URL_PROJECT_CLASS_SCHEDULE, info);
            },
            insertProjectClassScheduleTempInfo(info) {
                return axios.post(URL_PROJECT_CLASS_SCHEDULE + '/temp', info);
            },
            updateProjectClassScheduleInfo(info) {
                return axios.put(URL_PROJECT_CLASS_SCHEDULE + '/' + info.scheduleId, info);
            },
            updateProjectClassScheduleTempInfo(info) {
                return axios.put(URL_PROJECT_CLASS_SCHEDULE + '/temp/' + info.scheduleId, info);
            },
            deleteProjectClassScheduleInfo(scheduleId) {
                return axios.delete(URL_PROJECT_CLASS_SCHEDULE + '/' + scheduleId);
            },
            deleteProjectClassScheduleTempInfo(scheduleId) {
                return axios.delete(URL_PROJECT_CLASS_SCHEDULE + '/temp/' + scheduleId);
            },

            importProjectClassScheduleData(condition) {
                return axios.get(URL_PROJECT_CLASS_SCHEDULE_IMPORT, {params: condition});
            },
            importProjectClassScheduleTempData(condition) {
                return axios.get(URL_PROJECT_CLASS_SCHEDULE_IMPORT + '/temp', {params: condition});
            },
        },

        confirm: {
            getConfirmProject(batchId) {
                return axios.get(URL_CONFIRM_PROJECT + '/' + batchId);
            }
        }
    }
}
